// extracted by mini-css-extract-plugin
export default {"main":"Developers_main__MHoaA","main__top":"Developers_main__top__9y1pM"};